// extracted by mini-css-extract-plugin
module.exports = {"inner":"styles_inner__2rtOQ","errorLogs":"styles_errorLogs__3YFUA"};